/** returns BatchFiles List
@return { Array }
*/
export const getBatchFiles = state => {
    return state.batchFilesList
}

/** returns BatchFiles hasMore value
@return { Boolean }
*/
export const getBatchFilesHasMore = state => state.batchFilesHasMore
